'use client';

import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from '../index.module.scss';
import IconClose from './IconClose';
import IconCopy from './IconCopy';
import { tranText } from './tranText';
import getLocal from '@/app/utils/getLocal';

export default function WinItemASuccess({ data = {}, activeType, winItemCallback }: any) {
    const { locale } = getLocal();
    const textObj = tranText[locale] || tranText['us'];
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    const closeHandle = () => {
        winItemCallback && winItemCallback('close');
    };

    // 复制
    const copyHandle = (text?: string) => {
        if (!text) return;

        if (navigator?.clipboard && window?.isSecureContext) {
            window.navigator.clipboard.writeText(text);
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            new Promise(() => {
                const copyStatus = document.execCommand('copy');
                if (!copyStatus) {
                    // message.error()
                }
                textArea.remove();
            });
        }
    };

    if (isClient) {
        return ReactDOM.createPortal(
            <div className={`glo-editor-modal glo-editor-modal-show ${styles['eco-win']}`}>
                <div
                    className={`glo-editor-modal-content scrollbar-editor-white eco-redeem-rewards-winitem eco-redeem-rewards-winitem-success ${styles.content}`}
                >
                    <div className="glo-editor-modal-header">
                        <IconClose onClick={closeHandle} />
                    </div>
                    <div className={`glo-editor-modal-body eco-redeem-rewards-winitem-${activeType}`}>
                        <div className="eco-redeem-rewards-card">
                            <div className="eco-redeem-rewards-card-img">
                                <EditorImg pc={data.rulePic} />
                                <div className="eco-redeem-rewards-card-amount">
                                    <div className="eco-redeem-rewards-card-amount-l">{data?.amount}</div>
                                    <div className="eco-redeem-rewards-card-amount-r">
                                        <div className="eco-redeem-rewards-card-amount-line1">{data?.currencySymbol}</div>
                                        <div className="eco-redeem-rewards-card-amount-line2">{textObj.card_off}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="eco-redeem-rewards-card-desc">
                                <div className="eco-redeem-rewards-card-desc1">{data?.goodTitle || textObj.card_discount_code}</div>
                                <div className="eco-redeem-rewards-reward-key">
                                    {data?.coupon}
                                    <IconCopy
                                        onClick={() => {
                                            copyHandle(data?.coupon);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="eco-redeem-rewards-winitem-note">
                            <div className="eco-redeem-rewards-winsuccess-title">{textObj.win_a_success_title}</div>
                            <div className="eco-redeem-rewards-winsuccess-desc">{textObj.win_a_success_desc}</div>
                        </div>
                        <EditorLink href={data.jumpUrl || `https://${locale}.ecoflow.com`} className="eco-redeem-rewards-winitem-confirm">
                            {textObj.win_a_success_btn}
                        </EditorLink>
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
    return null;
}
